// Modules
import React from 'react';

// Hooks
import { useGatedCallback } from 'hooks';

// Actions
import { TRIAGE_QUEUE_SELECTOR } from './store/actions';

/**
 * Shows that a queue update is waiting for you to finish, and how long until it
 * lands.
 *
 * Renders nothing at all unless an update is actually being held — when the queue
 * is idle, updates apply immediately and there is nothing to say. The bar fills
 * over the quiet period and restarts on every interaction, so the wait is never a
 * mystery, and clicking applies it straight away.
 *
 * Keys off the same selector `useTriageItems` gates on, which is the whole reason
 * this needs nothing passed to it and can be rendered anywhere — it is mounted
 * outside the scrolling queue so that appearing cannot shift the list. It owns no
 * call of its own, hence the null: it reads the gate and can release it.
 */
export default function TriageRefreshIndicator() {
  const { flush, pending, progress } = useGatedCallback(null, {
    selector: TRIAGE_QUEUE_SELECTOR,
    progress: true
  });

  if (!pending) return null;

  return (
    <button
      type="button"
      className="triage-refresh-indicator"
      onClick={flush}
      title="Apply the update now"
    >
      <span className="triage-refresh-indicator-label">
        Queue update waiting &middot; refresh now
      </span>
      <span
        className="triage-refresh-indicator-bar"
        style={{ width: `${Math.round(progress * 100)}%` }}
      />
    </button>
  );
}
